import { useState } from 'react'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { CategoryFilter } from '@unholster/graphkit'
import Cancel from '@/assets/Cancel'
import MagGlass from '@/assets/MagGlass'
import { formatRutIfMissingDV } from '@/lib/utils'
import './styles.css'

interface TopMenuProps {
  setCategoryFilter: (filter: any) => void
  handleSearch: (search: string, depth: number) => Promise<any>
}

export default function TopMenu({ setCategoryFilter, handleSearch }: TopMenuProps) {
  const [search, setSearch] = useState('')
  const [depth, setDepth] = useState(1)
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async (
    e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLInputElement>
  ) => {
    e.preventDefault()
    const newSearch = search.trim()
    if (newSearch === '') return
    const query = formatRutIfMissingDV(newSearch)
    setIsLoading(true)
    try {
      await handleSearch(query, depth)
    } catch (error) {
      console.error('Search error:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleClear = () => {
    setSearch('')
  }

  const handleDepthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value)
    setDepth(value >= 1 && value <= 3 ? value : value < 1 ? 1 : 3)
  }

  return (
    <div className="flex-1 mx-8 mt-16 mb-2 w-9/12 h-32">
      <h1 className="text-xl font-bold">Mallas</h1>
      <Label>
        En esta vista podrás explorar las mallas relacionales entre personas naturales, jurídicas
        con sus actividades económicas, causas judiciales, relaciones familiares, societarias,
        sanciones y lugares de trabajo.
      </Label>
      <div className="flex flex-wrap justify-between items-center gap-4 mt-4">
        <div className="flex items-center gap-4 flex-1 min-w-[200px]">
          <div className="relative flex-1 min-w-[320px] max-w-[26.5%]">
            <Input
              placeholder="Ingresar rut, nombre o razón social"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleClick(e)
                }
              }}
              className="pr-14"
              disabled={isLoading}
            />
            {search.trim() !== '' && (
              <button
                onClick={handleClear}
                className="absolute right-16 top-1/2 -translate-y-1/2 flex items-center justify-center bg-gray-300 rounded-full w-4 h-4"
                aria-label="Limpiar búsqueda"
                disabled={isLoading}
              >
                <Cancel />
              </button>
            )}
            <button
              type="button"
              onClick={handleClick}
              className="absolute right-0 top-0 h-full bg-transparent text-gray-700 border-l border-gray-300 flex items-center justify-center px-4 focus:outline-none"
              disabled={isLoading}
              aria-label="Buscar"
            >
              <MagGlass />
            </button>
          </div>

          <div className="flex items-center">
            <Label className="mr-2">Profundidad:</Label>
            <Input
              type="number"
              min="1"
              max="3"
              value={depth}
              onChange={handleDepthChange}
              className="w-16 text-center"
              disabled={isLoading}
            />
          </div>

          <div className="custom-overrides flex">
            <CategoryFilter setCategoryFilter={setCategoryFilter} />
          </div>
        </div>
      </div>
    </div>
  )
}
